import React from 'react';
import { LabelAndValue } from '../../../../global/components/data-display/label-value';
import { DividerSection } from '../../../../global/components/layout/divider-section';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';
import { LabelSettingProps } from '../../../../global/models/epi-model';
import { GroupAdminAddFormValues } from '../../../arc/features/groups/admin/group-admin-add-form-model';
import { OfficerAddFormValues } from '../../../arc/features/institution-officers/officer-add-form-model';
import { DependentFormValues } from '../../features/dependents/dependent-form-models';
import { MaritalStatusFormValues } from '../../features/marital-status/marital-form-models';
import { MailingAddressFields } from '../../models/form-models';

interface Props {
    values: MaritalStatusFormValues | DependentFormValues | GroupAdminAddFormValues | OfficerAddFormValues | MailingAddressFields;
    labelSetting: LabelSettingProps;
}
export function MailingAddressDisplay(props: Props) {
    const { values, labelSetting } = props;

    const AddressView = () => {
        return (
            <>
                <p>{values.mailing_address_1}</p>
                {values.mailing_address_2 && <p>{values.mailing_address_2}</p>}
                {values.mailing_address_3 && <p>{values.mailing_address_3}</p>}
                <p>{values.mailing_city}{values.mailing_state && `, ${values.mailing_state}`}{values.mailing_postal_code && `, ${values.mailing_postal_code}`}</p>
                <p>{values.mailing_country}</p>
            </>
        );
    };

    return (
        <DividerSection removeDivider>
            <ContentSpacer>
                <h3>{labelSetting.mailingAddressTitle}</h3>
            </ContentSpacer>
            <LabelAndValue label={labelSetting.addressLabel} value={<AddressView />} />
        </DividerSection>

    );
}